import { Card, CardBody, Col, Toast, ToastBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { TranslucentToast } from "../../../../Constant";
import { TRANSLUCENT_TOAST, TRANSLUCENT_TOAST_LIST } from "../../../../Data/Bonus Ui/Toasts";
import { Disc } from "react-feather";
import { Btn } from "../../../../AbstractElements";
import { CommonToast } from "../Common/CommonToast";
import { useState } from "react";

const TranslucentToasts = () => {
  const [open, setOpen] = useState(true);

  return (
    <Col md="6">
      <Card className="overflow-hidden">
        <CommonCardHeader title={TranslucentToast} span={TRANSLUCENT_TOAST} />
        <CardBody className="toast-rtl bg-dark">
          <div className="toast-container">
            <Toast isOpen={open}>
              <div className="toast-header">
                <Disc className="toast-icons toast-info" />
                <strong className="me-auto">Boho theme</strong>
                <small className="text-muted d-sm-block d-none">11 mins ago</small>
                <Btn className="btn-close p-0" onClick={() => setOpen(false)}></Btn>
              </div>
              <ToastBody className="toast-dark"> Hello, I'm a web-designer.</ToastBody>
            </Toast>
            {TRANSLUCENT_TOAST_LIST.map((data, index) => (
              <CommonToast item={data} key={index} />
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TranslucentToasts;
